import React from "react";
import { observable, toJS } from "mobx";
import LoadingImage from "../../comum/components/LoadingImage";
import { buscaFiltrarVazio, buscaSemResultado } from "../../../utils/mensagens";
import { sortCaret, IconeGenerico } from "../../comum/components/Icones";
import { formatarDataCustomHTML } from "../../../utils/formatar";
import ModalDocumentos from "../components/ModalDocumentos";

export default class AcompServicosStore {

    @observable servicosLista;

    // Scroll infinito
    @observable lista;
    @observable items;
    toShow;
    turn;
    @observable hasMore;
    @observable noData;
    @observable linhaExpandida;
    @observable tableMessage;
    @observable loading;

    colunasExportacao;

    constructor(service) {
        this.servicosLista = [];

        this.colunas = this.todasColunas;

        // Scroll infinito
        this.lista = [];
        this.toShow = 20;
        this.turn = 0;
        this.items = [];
        this.hasMore = false;
        this.noData = <LoadingImage />;
        this.tableMessage = buscaFiltrarVazio;
        this.loading = false;

        this.colunasExportacao = this.colunas.slice(0);
        this.colunasExportacao = this.colunasExportacao.concat(this.outrosDados);

        this.service = service;
    }

    // -----------------------
    // Listagem
    // -----------------------
    listar(filtros) {
        this.estadoFiltros = filtros;
        this.fazerListar(filtros);
    };

    reListar = () => {
        this.fazerListar(this.estadoFiltros);
    };

    fazerListar = (filtros) => {
        this.servicosLista = [];
        this.lista = [];
        this.items = [];
        this.loading = true;

        this.service.listar(
            filtros.parcidId,
            filtros.dataInicial,
            filtros.dataFinal,
            filtros.tipoServId,
            filtros.numeroBl,
            filtros.container,
            filtros.status
        ).then(response => {
            if (response.data) {
                this.servicosLista = response.data;
            }

            if (this.servicosLista.length === 0) {
                this.tableMessage = buscaSemResultado;
            } else {
                this.tableMessage = buscaFiltrarVazio;
            }

            this.lista = this.servicosLista;
            this.noData = this.tableMessage;
            this.loadFirstTurn();
        }).catch(() => {
            this.servicosLista = [];
            this.lista = [];
            this.items = [];
            this.tableMessage = buscaSemResultado;
            this.noData = buscaSemResultado;
        }).finally(() => {
            this.loading = false;
        });
    };

    loadFirstTurn = () => {
        this.items = this.servicosLista.slice(0, this.toShow);
        this.turn = 1;
        this.hasMore = this.items.length < this.lista.length;
    };

    loadNextTurn = () => {
        this.items = this.lista.slice(0, (this.turn + 1) * this.toShow);
        this.turn = this.turn + 1;
        this.hasMore = this.items.length < this.lista.length;
    };

    formatarPosicCustomHTML = (cell, row) => {
        const dataPosic = row && row.DataPosic
            ? row.DataPosic
            : cell;

        if (!dataPosic) {
            return "---";
        }

        return formatarDataCustomHTML(dataPosic);
    };

    // -----------------------
    // Exportar
    // -----------------------
    getLista() {
        return this.servicosLista;
    }

    getListaCopia() {
        return toJS(this.servicosLista);
    }

    // -----------------------
    // Colunas
    // -----------------------
    todasColunas = [
        { dataField: 'NumeroBl', text: 'BL', sort: true, sortCaret, headerAlign: 'left' },
        { dataField: 'CodCntr', text: 'Container', sort: true, sortCaret, headerAlign: 'left' },
        { dataField: 'DescServ', text: 'Serviço', sort: true, sortCaret, headerAlign: 'left' },
        { dataField: 'DataAgend', text: 'Solicitação', sort: true, sortCaret, formatter: formatarDataCustomHTML, headerAlign: 'left' },
        { dataField: 'DataPrev', text: 'Início Prev', sort: true, sortCaret, formatter: formatarDataCustomHTML, headerAlign: 'left' },
        { dataField: 'DataPosic', text: 'Posic.', sort: true, sortCaret, formatter: this.formatarPosicCustomHTML, headerAlign: 'left' },
        { dataField: 'DataExecucao', text: 'Em Andamento', sort: true, sortCaret, formatter: formatarDataCustomHTML, headerAlign: 'left' },
        { dataField: 'DataConcl', text: 'Conclusão', sort: true, sortCaret, formatter: formatarDataCustomHTML, headerAlign: 'left' },
        {
            dataField: 'OsId',
            text: 'Documentos',
            headerAlign: 'center',
            align: 'center',
            headerStyle: { width: '110px' },
            formatter: (cell, row) => {
                const osId = row && row.OsId
                    ? row.OsId
                    : cell;

                return (
                    <button
                        type="button"
                        className="btn btn-link p-0"
                        title="Documentos"
                        onClick={() => this.abrirModalDocumentos(osId)}
                    >
                        <IconeGenerico icone="file-alt" tamanho="lg" />
                    </button>
                );
            }
        }
    ];

    outrosDados = [
        { titulo: "Código", field: ["OsId"], id: "F1", hidden: false, dataField: 'OsId', text: 'Código' },
        { titulo: "Placa", field: ["Placa"], id: "F2", hidden: false, dataField: 'Placa', text: 'Placa' },
        { titulo: "Agendado por", field: ["LoginAgend"], id: "F3", hidden: false, dataField: 'LoginAgend', text: 'Agendado por' }
    ];

    // -----------------------
    // Documentos (Modal)
    // -----------------------
    @observable anexos = [];
    @observable modalDocumentosAberto = false;
    @observable loadingDocumentos = false;

    abrirModalDocumentos = (osId) => {
        this.loadingDocumentos = true;
        this.anexos = [];

        this.service.getAnexos(osId)
            .then(response => {
                const data = response && response.status && response.status >= 400
                    ? []
                    : (response && response.data);

                this.anexos = Array.isArray(data) ? data : [];
            })
            .catch(() => {
                this.anexos = [];
            })
            .finally(() => {
                this.loadingDocumentos = false;
                this.modalDocumentosAberto = true;
            });
    };

    fecharModalDocumentos = () => {
        this.modalDocumentosAberto = false;
    };

    baixarAnexo = (anexo) => {
        const id = anexo.Id || anexo.id;

        this.service.baixarDocumento(id)
            .then(response => {
                if (!response || response.status >= 400) {
                    return;
                }

                const nomeArquivo =
                    anexo.NomeArquivo ||
                    anexo.nomeArquivo ||
                    `anexo_${id}`;

                const contentType =
                    response.headers && response.headers["content-type"]
                        ? response.headers["content-type"]
                        : "application/octet-stream";

                const blob = new Blob([response.data], {
                    type: contentType
                });

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");

                link.href = url;
                link.download = nomeArquivo;

                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            });
    };

}


// WEBPACK FOOTER //
// ./src/modules/acompanhamentoservico/stores/AcompServicosStore.js